<div class="offline-modal-container text-center bg-white m-auto relative"
	[ngClass]=" customStyle ? customStyle : 'w-72 md:w-84'"
>
	<div class=" header-modal py-3 px-2 lg:py-3.5 font-bold text-base leading-5 text-white text-center relative bg-primary" >
		<span >{{translations?.OFFLINE.SE_HA_PERDIDO_LA_CONEXION_A_INTERNET || ''}} </span>
	</div>

	<div *ngIf="translations" class="flex flex-col px-4 py-4 text-gray-900 text-left text-base font-normal leading-5">
    <div class="flex justify-center items-center flex-col gap-5 max-w-[320px] text-center mx-auto">
      <app-image-svg name="offline-cow" customClass="text-secondary w-44 h-44" class=""></app-image-svg>
      <h2 class="font-bold text-xl">{{translations.OFFLINE.UPS_NO_TIENES_CONEXION_A_INTERNET }}</h2>
      <p *ngIf="hasOfflineChecklistAvailable || hasOfflineCoursesAvailable" class="text-sm">
        {{translations?.OFFLINE.NO_PODEMOS_CONECTARNOS_A_UNA_RED_DE_INTERNET_PERO_SI_DESEAS_PUEDES_VER_TU_CONTENDIO_DESCARGADO }}
      </p>
    </div>

    <div class="flex justify-center items-center gap-8 mt-5">
        <app-primary-button
        *ngIf="hasOfflineChecklistAvailable"
        (btnClick)="goToOfflineChecklist()"
        class=""
        normalBtn="true"
        customClassAppBtn=""
        >
         {{translations?.OFFLINE.IR_CHECKLIST }}
        </app-primary-button>

       <app-primary-button
       *ngIf="hasOfflineCoursesAvailable"
        (btnClick)="goToOfflineCourses()"
        class=""
        normalBtn="true"
        customClassAppBtn=""
        >
         {{translations?.OFFLINE.IR_CURSOS }}
        </app-primary-button>



    </div>
	</div>
</div>

